import React from "react";
import { Carousel } from "antd";

/**
 * OffersCarousel renders a simple image carousel with optional fallback.
 * @param {Object} props
 * @param {Array<{id?: number|string, image: string, title?: string, order?: number}>} props.images
 * @param {number} props.speed autoplay speed in ms
 * @param {string} props.fallbackSrc fallback image url (required)
 * @param {string} [props.className] optional className for wrapper
 */
const OffersCarousel = ({ images = [], speed = 3000, fallbackSrc, className = "" }) => {
  const hasImages = images && images.length > 0;

  if (!hasImages) {
    return (
      <img
        src={fallbackSrc}
        alt="Offer"
        className="modern-signin-graphic"
      />
    );
  }

  return (
    <Carousel
      autoplay
      autoplaySpeed={speed || 3000}
      dots
      className={`modern-signin-offers-carousel ${className}`.trim()}
    >
      {images.map((imageItem, index) => (
        <div key={imageItem.id || index}>
          <img
            src={imageItem.image}
            alt={imageItem.title || `Offer ${index + 1}`}
            className="modern-signin-carousel-image"
            onError={(e) => {
              // Hide broken images to avoid blank slides
              e.target.style.display = "none";
              // eslint-disable-next-line no-console
              console.error("Image failed to load:", imageItem.image);
            }}
          />
        </div>
      ))}
    </Carousel>
  );
};

export default OffersCarousel;

